enum QueryParam {
  TRANSLATIONS = 'translations',
  RECITER = 'mediaReciter',
  WBW_LOCALE = 'wbw_locale',
  HIDE_ARABIC = 'hideArabic',
  FLOW = 'flow',
  STARTING_VERSE = 'startingVerse',
  QUERY = 'query',
  REDIRECT_TO = 'r',
  VERSE_TO = 'verseTo',
  VERSE_FROM = 'verseFrom',
  OPACITY = 'opacity',
  QURAN_TEXT_FONT_SCALE = 'quranTextFontScale',
  QURAN_TEXT_FONT_STYLE = 'quranTextFontStyle',
  TRANSLATION_FONT_SCALE = 'translationFontScale',
  FONT_COLOR = 'fontColor',
  BACKGROUND_COLOR = 'backgroundColor',
  BORDER_COLOR = 'borderColor',
  BORDER_SIZE = 'borderSize',
  VERSE_ALIGNMENT = 'verseAlignment',
  TRANSLATION_ALIGNMENT = 'translationAlignment',
  ORIENTATION = 'orientation',
  VIDEO_ID = 'videoId',
  SURAH = 'surah',
}

export default QueryParam;
